import React from "react";

import "./spread-overview-item.css";
import { SpreadOverviewThumbContainer } from "./spread-overview-thumb-container";
import { IconButton } from "../icon-button";

/** Contains one spread thumb with allowed buttons */
export const SpreadOverviewItem = ({
	spread,
	spreadName,
	disableAddSpreadButton,
	hideAddSpreadButton,
	onAddSpread,
	isSelected,
	onSelect,
}: {
	spread: eXpress.core.Spread;
	spreadName: string;
	disableAddSpreadButton?: boolean;
	hideAddSpreadButton?: boolean;
	onAddSpread: () => void;
	isSelected: boolean;
	onSelect: () => void;
}) => {
	// if hideAddSpreadButton is true and it's the last spread, hide the whole below section
	const hideBelow = hideAddSpreadButton && spread.index + 1 === spread.definition?.spreadCount;

	return (
		<div className="spread-overview-item">
			<SpreadOverviewThumbContainer
				spread={spread}
				isSelected={isSelected}
				onClick={onSelect}
			/>
			<div className="spread-overview-item__caption">{spreadName}</div>
			{!hideBelow && (
				<div className="spread-overview-item__below">
					{!hideAddSpreadButton && (
						<IconButton
							iconName="plus-circle"
							onClick={onAddSpread}
							disabled={disableAddSpreadButton}
						/>
					)}
				</div>
			)}
		</div>
	);
};
